
const hubConnectionTypes = {
    ETHERNET: 'ETHERNET',
    WIFI: 'WIFI' 
}

export {
    hubConnectionTypes
}